import JsSha from 'jssha';

export const makeHash = (value) => {
  const hashObj = new JsSha('SHA3-512', 'TEXT');
  hashObj.update(value);
  return hashObj.getHash('HEX');
};
